import { EdgeTypes } from '@ply-io/ply-front-shared-utilities';

import { MODULE_NAME } from './const';
import StoreModuleService from '../StoreModuleService';
import { getNode } from '../nodes/getters';
import FlowTreeService from '@/components/FlowTree/flow-tree-service';
import { useEdge, useWorkflowVersionEdges } from '@/store/modules/edges/getters';
import { useNodePathsFromRoot, useIsNodeInBranch } from '@/store/modules/workflowGraphs/getters';
import { nodesDataArray, rootNodeId as rootNodeIdGetter } from '@/store/modules/workflows/getters';
import * as WorkflowNodeService from '@/utils/workflow-node-service';
const buildTreeBlockGetterObject = (getter) => StoreModuleService.buildGetterObject(MODULE_NAME, getter);

// getters declarations
export const lastNode = buildTreeBlockGetterObject('lastNode');
export const isMoveNodeActive = buildTreeBlockGetterObject('isMoveNodeActive');
export const nodeIdToMove = buildTreeBlockGetterObject('nodeIdToMove');
export const isEndRunNodePossible = buildTreeBlockGetterObject('isEndRunNodePossible');
export const moveNodeLoading = buildTreeBlockGetterObject('moveNodeLoading');
export const tempBlock = buildTreeBlockGetterObject('tempBlock');
export const isEndRunLoading = buildTreeBlockGetterObject('isEndRunLoading');
export const useWorkflowVersionGraph = buildTreeBlockGetterObject('useWorkflowVersionGraph');
export const useIsNodeReachable = buildTreeBlockGetterObject('useIsNodeReachable');
export const useShortcutCommand = buildTreeBlockGetterObject('shortcutCommand');
export const useIsEdgeInBranch = buildTreeBlockGetterObject('useIsEdgeInBranch');

const getNodesOfWorkflowVersion = ({ rootGetters, workflowId, workflowVersionId }) =>
	rootGetters[nodesDataArray.fullPath](workflowId, workflowVersionId);

const isNodeInBranch = ({ rootGetters, nodeId }) => {
	const node = rootGetters[getNode.fullPath](nodeId);
	const nodes = getNodesOfWorkflowVersion({ rootGetters, workflowId: node.workflow, workflowVersionId: node.workflow_version });
	return rootGetters[useIsNodeInBranch.fullPath]({
		node,
		nodes,
	});
};

const isEdgeInBranch = ({ rootGetters, edge }) => edge.type === EdgeTypes.Diverge || isNodeInBranch({ rootGetters, nodeId: edge.source });

const getters = {
	[isMoveNodeActive.getter]: (state) => state.moveNodeActive,
	[isEndRunLoading.getter]: (state) => state.isEndRunLoading,
	[nodeIdToMove.getter]: (state) => state.nodeIdToMove,
	[tempBlock.getter]: (state) => state.tempBlock,
	[isEndRunNodePossible.getter]: (state, getters, rootState, rootGetters) => (nodeId) => {
		if (WorkflowNodeService.isNodeTemp({ id: nodeId })) {
			return getters[useIsEdgeInBranch.getter](getters[tempBlock.getter].edge);
		} else {
			return isNodeInBranch({ rootGetters, nodeId });
		}
	},
	[moveNodeLoading.getter]: (state) => state.moveNodeLoading,
	[useWorkflowVersionGraph.getter]: (state, getters, rootState, rootGetters) => (workflowId, workflowVersionId) => ({
		edges: rootGetters[useWorkflowVersionEdges.fullPath](workflowVersionId),
		nodes: getNodesOfWorkflowVersion({ rootGetters, workflowId, workflowVersionId }),
	}),
	[useIsNodeReachable.getter]:
		(state, getters, rootState, rootGetters) =>
		({ node }) => {
			const rootNodeId = rootGetters[rootNodeIdGetter.fullPath](node.workflow, node.workflow_version);
			if (rootNodeId === node.id) {
				return true;
			}
			const pathsToNode = rootGetters[useNodePathsFromRoot.fullPath]({ node });
			return FlowTreeService.isNodeReachable(pathsToNode);
		},
	[useShortcutCommand.getter]: (state) => state.shortcutCommand,
	[useIsEdgeInBranch.getter]: (state, getters, rootState, rootGetters) => (edgeId) => {
		const edge = rootGetters[useEdge.fullPath](edgeId);
		return edge && isEdgeInBranch({ rootGetters, edge });
	},
};

export default getters;
